import { AccessTime, Store, Style } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { ColorHexCodes } from "../util/Color";
import Time from "../util/Time";
import type { ReservationState } from "../util/useReservationState";
import Breakable from "./Breakable";
import { StyledText } from "./StyledText";

export function FloatingUIForm1() {
  return <div></div>;
}

export function FloatingUI({ state, canGoBack, isValid, onPrev, onNext }: { state: ReservationState; canGoBack: boolean; isValid: boolean; onPrev: () => void; onNext: () => void }) {
  if (!state.data.date || !state.data.store) {
    return <></>;
  }

  const nextButtonText = state.data.store.skip_confirm ? "予約確定" : "次へ";
  const ds = new Time(state.data.date).DateStrings();
  return (
    <Stack style={{ alignItems: "center", background: "white", bottom: 0, boxShadow: "0 0 20px gray", left: 0, padding: "18px 32px", position: "fixed", width: "100vw" }}>
      <Stack flex={1} maxWidth={540} style={{ gap: "6px" }} width={"100%"}>
        <Stack alignItems={"center"} flexDirection={"row"} style={{ fontSize: 15, gap: "10px" }}>
          <Store />
          <StyledText>{state.data.store.name}</StyledText>
        </Stack>
        <Stack alignItems={"center"} direction={"row"} style={{ fontSize: 15, gap: "10px" }}>
          <Style />
          <StyledText>{state.data.course?.name}</StyledText>
        </Stack>
        <Stack alignItems={"center"} direction={"row"} style={{ gap: "10px" }}>
          <AccessTime />
          <Breakable texts={[`${ds.year}年${ds.month}月${ds.date}日(${ds.day})`, `${ds.hour}時${ds.minute}分`, ` (${(state.data.course?.duration ?? 0) / Time.AMinute}分間)`]} />
        </Stack>
        <Stack direction="row" flex={1} spacing={1} width={"100%"}>
          <Button color="inherit" disabled={!canGoBack} onClick={onPrev} sx={{ flexGrow: 1, padding: "10px 0" }} variant="contained">
            戻る
          </Button>
          <Button color="primary" disabled={!isValid} onClick={onNext} sx={{ color: "white", flexGrow: 1, padding: "10px 0" }} variant="contained">
            {nextButtonText}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

export function FloatingConfirmUI({ onPrev, onNext }: { onPrev: () => void; onNext: () => void }) {
  return (
    <Stack style={{ alignItems: "center", background: "white", bottom: 0, boxShadow: "0 0 20px gray", left: 0, padding: "18px 32px", position: "fixed", width: "100vw" }}>
      <Stack flex={1} maxWidth={540} style={{ gap: "6px" }} width={"100%"}>
        <Stack style={{ alignItems: "center", color: `#${ColorHexCodes.RequiredRed}` }}>
          <StyledText textStyle={"Bold"}>{"!予約はまだ完了していません!"}</StyledText>
          <StyledText>{"内容に問題がなければ【予約確定】ボタンを押してください"}</StyledText>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <Button color="inherit" onClick={onPrev} sx={{ flex: 1, padding: "10px 0" }} variant="contained">
            戻る
          </Button>
          <Button color="primary" onClick={onNext} sx={{ color: "white", flex: 1, padding: "10px 0" }} variant="contained">
            予約確定
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
